import { render, staticRenderFns } from "./BatchEditAttributes.vue?vue&type=template&id=5afef3a2"
import script from "./BatchEditAttributes.vue?vue&type=script&lang=js"
export * from "./BatchEditAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports